// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxListItem_wrapper__Qu_cE","title":"BoxListItem_title__PGWZ5","description":"BoxListItem_description__jyemx"};